import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {CreepyCarnivalTwoGameConfig} from "../CreepyCarnivalTwoGameConfig";
import { Device } from "@nolimitcity/slot-launcher/bin/interfaces/APIOptions";

export class CCTwoHelper extends Helper {

    public static getSymbolPositions(reelId:number, symId:number, realSymbolPosition?: boolean, device?:Device):[number, number] {
        const numOfRows = 3,
            columnIndex = 0;

        if(!device) {
            device = UserAgent.deviceName;
        }
        const reelAreaPositions:[number, number] = [CreepyCarnivalTwoGameConfig.instance.REEL_AREA_POS_X, CreepyCarnivalTwoGameConfig.instance.REEL_AREA_POS_Y];
        const symbolPositionsOnReelArea:[number, number] = Helper.getSymbolPositionsOnReelArea(reelId * numOfRows + symId, columnIndex, realSymbolPosition, device);
        return [reelAreaPositions[0] + symbolPositionsOnReelArea[0], reelAreaPositions[1] + symbolPositionsOnReelArea[1]];
    }
}